import React from "react";
import { Box } from "@mui/material";

export default function CardButton({
  label,
  value,
  percentage,
  caption,
  borderColor,
  arrowDirection,
}) {
  // ✅ Normalize direction

  const direction = arrowDirection || "Up";
  const isUp = direction === "Up";
  const isDown = direction === "Down";
  
  // ✅ Colors
  const arrowColor = isUp ? "var(--green-400)" : "var(--red-900)";
  const arrowBg = isUp ? "var(--green-10)" : "var(--red-200)";
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        paddingX: "1rem",
        borderRadius: 3,
        background: "var(--gray-0)",
        boxShadow: "0 1px 3px var(--gray-960)",
        height: "120px",
        borderLeft: `4px solid ${borderColor}`,
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        maxWidth: { xs: "200px", sm: "260px", md: "280px", xl: "550px" },
      }}
    >
      <Box sx={{ flex: 1 }}>
        {/* Label */}
        <Box
          sx={{ fontSize: "14px", fontWeight: 500, color: "var(--gray-800)" }}
        >
          {label}
        </Box>

        {/* Value */}
        <Box sx={{ fontSize: "1.5rem", fontWeight: 600, mt: "0.25rem" }}>
          {value}
        </Box>

        {/* Arrow + Percentage */}
        <Box sx={{ display: "flex", alignItems: "center", mt: "0.75rem" }}>
          {/* Arrow Box */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: arrowBg,
              borderRadius: "0.375rem",
              p: "0.25rem",
              mr: "0.5rem",
            }}
          >
            <svg
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke={arrowColor}
              style={{
                width: "1rem",
                height: "1rem",
                transform: isDown ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.2s ease",
              }}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5 10l7-7m0 0l7 7m-7-7v18"
              />
            </svg>
          </Box>

          {/* Percentage + Caption */}
          <span
            style={{
              color: arrowColor,
              fontWeight: 600,
              marginRight: "0.25rem",
              fontSize: "1rem",
            }}
          >
            {percentage}%
          </span>
          <span style={{ color: "var(--gray-450)", fontSize: "0.875rem" }}>
            {caption}
          </span>
        </Box>
      </Box>
    </Box>
  );
}
